
















































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import Dynamic from "./componts/Dynamic.vue";
import { CollegesService } from "@/zh-website/src/views/Colleges/service";
import Fives from "./componts/Fives.vue";
import Write from "./componts/Write.vue";
import Ai from "./componts/Ai.vue";
import Cooperation from "./componts/Cooperation.vue";
import Education from "./componts/Education.vue";
@Component({
  components: {
    Education,
    Cooperation,
    Ai,
    Write,
    Fives,
    SideBar,
    Banner,
    Dynamic
  }
})
export default class Teach extends Vue {
  isFixed = false;
  offsetTop = 600;
  // 选中的项
  activeIndex: any = "";
  dynamic = [];
  // 背景图样式文案
  list = {
    style: {
      backgroundImage: `url(${require("../../assets/teach_banner.jpg")})`,
      height: "493px"
    },
    font1: "教育合作",
    font2: "",
    font3: "",
    font9: `产教科融合 与生态圈共赢`,
    font5: "",
    button: ""
  };
  tabs: any[] = [];
  /*tabs = [
    {
      title: "协同育人",
      content: "<p>asfasfasfsd</p>",
      dynamic: []
    }
    /!*{
      title: "5G 联盟"
    },
    {
      title: "学会合作"
    },
    {
      title: "AI 生态"
    },
    {
      title: "教材编写"
    }*!/
  ];*/
  staticMatchList = [
    {
      host: "https://www.zj-huawei.com",
      ids: {
        five: "1713879589720035330",
        jcbx: "1714532684892348418",
        ai: "1714533167096885250",
        xhhz: "1714533694119571458",
        xtyr: "1714534162864414721"
      }
    },
    {
      host: "https://icsl-pc.zj-huawei.com",
      ids: {
        five: "1713879589720035330",
        jcbx: "1714532684892348418",
        ai: "1714533167096885250",
        xhhz: "1714533694119571458",
        xtyr: "1714534162864414721"
      }
    },
    {
      host: "https://test-pc.zj-huawei.com",
      ids: { five: "", jcbx: "", ai: "", xhhz: "", xtyr: "" }
    },
    {
      host: "https://dev-pc.zj-huawei.com",
      ids: { five: "", jcbx: "", ai: "", xhhz: "", xtyr: "" }
    }
  ];
  currentStaticIds: any = {
    five: "1713879589720035330",
    jcbx: "1714532684892348418",
    ai: "1714533167096885250",
    xhhz: "1714533694119571458",
    xtyr: "1714534162864414721"
  };
  mounted() {
    this.activeIndex = this.currentStaticIds.five
    this.getCategory();
    window.addEventListener("scroll", this.handleScroll);
  }

  // 鼠标hover事件
  changeMask(e, dictCode) {
    this.getDynamic(dictCode);
    this.activeIndex = e;
    // 判断当前tab有没有吸顶
    if (this.isFixed) {
      this.$nextTick(() => {
        window.scrollTo({
          top: this.offsetTop,
          behavior: "smooth"
        });
      });
    }
  }
  //动态进展
  async getDynamic(dictCode) {
    // const _this = this;
    // try {
    //   const res = await this.$ajax.get(
    //     "/webAction/list/huawei_data?group=034&dictCode=" + dictCode
    //   );
    //   _this.dynamic = res.data.result.data;
    // } catch (err) {}
  }
  //合作类别
  async getCategory() {

    CollegesService.getCooperationList({}).then((res: any) => {


      res.data.forEach((item: any) => {
        const tmp: any[] = [];
        item.dynamicProgressList &&
          item.dynamicProgressList.forEach((element: any) => {
            tmp.push({
              aid: element.id,
              id: item.id,
              content1: element.subtitle,
              field1: element.title,
              field2: element.resourceUrl,
              field3: element.publishTime
            });
          });
        this.tabs.push({
          id:item.id,
          title: item.title,
          content: item.content,
          dynamic: tmp
        });
        this.activeIndex = this.tabs[0].id;
      });
    });
  }

  destroyed() {
    //
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll() {
    const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    const offsetTop = document.getElementById("bar")?.offsetTop;


    if (scrollTop > this.offsetTop) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }
  }
}
